import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { cnmcQueryKeys } from './query-keys';

export type TPauseCNMCParams = {
  cnmcId: string;
};

export async function pauseCNMC({ cnmcId }: TPauseCNMCParams): Promise<undefined> {
  return mediaManagerClient.post(`/api/v1/cnmcs/${cnmcId}/pause`);
}

type MutationFn = typeof pauseCNMC;

type TUsePauseCNMCParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePauseCNMC({ config = {} }: TUsePauseCNMCParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: pauseCNMC,
    onError: error => {
      const { status } = parseError(error);
      if (status === 404) {
        addErrorNotification('El proceso no existe');
      } else {
        addErrorNotification('Error al pausar el proceso de IA');
      }
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: cnmcQueryKeys.all });
      addSuccessNotification('Proceso de IA pausado con éxito');
    },
  });
}
